import { store } from '../../store'
import { INVALIDATE_VIEWER_CONFIG } from '../../redux/project'

/**
 * `components/Viewer.tsx` serves an app straight from its redux copy when that
 * copy is marked `loaded`, so an app edited through the v2 GUI would open with
 * the pre-edit config until a full page reload.
 *
 * Every v2 mutation that changes an app must call this.
 */
export function invalidateLegacyViewerConfig(viewerId: string) {
  store.dispatch({ type: INVALIDATE_VIEWER_CONFIG, data: { id: viewerId } })
}
